export enum SystemTemplateApiError {
    Success = 0,
    InvalidTemplateCompanyScenario = 1,
    NameExists = 2,
    NameEmpty = 3,
    InvalidIntegration = 4,
    InvalidPersona = 5,
}

export type IntegrationDTO = {
    IntegrationID: number;
    IntegrationName: string;
};

export type SystemTemplateModel = {
    key: string;
    name: string;
    group: string;
    description: string;
    integrations: number[];
    personas: number[];
    selectedDomains: string;
    userType: string;
    status: number;
    lastModifiedDate: string;
    lastModifiedBy: string;
    permissionName: string;
};
